import { ChangeEvent, useCallback, FC } from 'react';
import { AutoExpandTextArea } from '../../../components/AutoExpandTextArea';
import { Card } from '../../../components/Card';
import { ChoiceInput } from '../ChoiceInput';
import { ImageInput } from '../ImageInput';
import {
  updateQuestionText,
  useCurrentAnswer,
  useCurrentQuestion,
  useInspectionPages,
} from '../../../services/inspection';
import { QuestionType } from '../types';
import { QuestionTitle } from '../views';
import styles from './Question.module.css';
import { useIntl } from 'react-intl';
import { SignatureInput } from '../SignatureInput';

export const Question: FC = () => {
  const { $t } = useIntl();
  const question = useCurrentQuestion();
  const { answer } = useCurrentAnswer();
  const { current } = useInspectionPages();

  const onTextChange = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) =>
      updateQuestionText(question.id, e.target.value),
    [question.id]
  );

  return (
    <Card className={styles.card}>
      <QuestionTitle index={current + 1}>{question.text}</QuestionTitle>
      {question.type === QuestionType.CLOSED && <ChoiceInput />}
      <div className={styles.container}>
        {question.type !== QuestionType.SIGNATURE ? (
          <>
            <AutoExpandTextArea
              key={question.id}
              placeholder={`${$t({ id: 'Comment.Add' })}...`}
              value={answer}
              onChange={onTextChange}
            />
            <hr className={styles.divider} />
            <ImageInput />
          </>
        ) : (
          <SignatureInput />
        )}
      </div>
    </Card>
  );
};
